var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49593 11.9919C9.53126 11.9919 11.9919 9.53126 11.9919 6.49593C11.9919 3.46061 9.53126 1 6.49593 1C3.46061 1 1 3.46061 1 6.49593C1 9.53126 3.46061 11.9919 6.49593 11.9919Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49611 11.1465C9.06446 11.1465 11.1465 9.06446 11.1465 6.49611C11.1465 3.92776 9.06446 1.8457 6.49611 1.8457C3.92776 1.8457 1.8457 3.92776 1.8457 6.49611C1.8457 9.06446 3.92776 11.1465 6.49611 11.1465Z",
    stroke: "#A7AFC0",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5156 9.97266L13.3955 12.8525",
    stroke: "#A7AFC0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBar);
export default __webpack_public_path__ + "static/media/search-bar.698ebf9c2e5ee2e2135adbc1e4d5994c.svg";
export { ForwardRef as ReactComponent };